import { useEffect, useRef } from 'react';
import { unitTypes } from '@/mocks/homeData';

export default function UnitTypes() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in-up');
            entry.target.classList.remove('opacity-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="units" ref={sectionRef} className="relative w-full py-20 md:py-32 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="reveal opacity-0 inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-widest text-foreground-600 border border-foreground-300 rounded-full uppercase">
            Unit Types
          </span>
          <h2 className="reveal opacity-0 font-heading text-4xl md:text-5xl font-semibold text-foreground-900 mb-4 text-balance">
            다양한 평형 안내
          </h2>
          <p className="reveal opacity-0 text-foreground-600 text-lg md:text-xl max-w-2xl mx-auto">
            59㎡ / 71㎡ / 84㎡ 세 가지 평형으로 라이프스타일에 맞는 최적의 공간을 선택하세요
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {unitTypes.map((unit, i) => (
            <div
              key={unit.name}
              className="reveal opacity-0 group relative rounded-2xl bg-background-100 border border-background-200/50 overflow-hidden transition-all hover:shadow-lg hover:-translate-y-1"
              style={{ animationDelay: `${i * 150}ms` }}
            >
              {unit.label && (
                <span className="absolute top-4 left-4 z-10 px-3 py-1 text-sm font-semibold rounded-full bg-accent-500 text-background-50">
                  {unit.label}
                </span>
              )}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={unit.image}
                  alt={`${unit.name} 타입 세대 내부`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  width={600}
                  height={500}
                />
              </div>
              <div className="p-5 text-center">
                <div className="flex items-center justify-center gap-2 mb-2">
                  <h3 className="text-xl font-bold text-foreground-900">{unit.name}</h3>
                  <span className="text-sm px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                    {unit.rooms}
                  </span>
                </div>
                <p className="text-base text-foreground-500 mb-1">전용면적 {unit.area}</p>
                <p className="text-sm text-foreground-400 mb-2">{unit.supply}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="reveal opacity-0 mt-6 text-center text-xs text-foreground-400">
          * 상기 이미지는 이해를 돕기 위한 이미지로 실제와 다를 수 있습니다.
        </p>
      </div>
    </section>
  );
}